import { useMediaQuery, useTheme } from '@mui/material';

export const useMobileLayout = () => {
  const theme = useTheme();

  return useMediaQuery(theme.breakpoints.down('sm'), {
    noSsr: true,
  });
};
